/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ImportStationTagsGnlDefinition$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The opcua Uid.
 */
  opcuaUid: string;

/**
 * Indicates if the imports can create tags or only updates them.
 */
  allowCreate?: boolean;
      body?: Blob
}

export function importStationTagsGnlDefinition(http: HttpClient, rootUrl: string, params: ImportStationTagsGnlDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, importStationTagsGnlDefinition.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('opcuaUid', params.opcuaUid, {});
    rb.query('allowCreate', params.allowCreate, {});
    rb.body(params.body, 'application/vnd.ms-excel');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

importStationTagsGnlDefinition.PATH = '/custom/stations/{uid}/opcua/configuration/gnl/{opcuaUid}/import';
